module.exports = __webpack_public_path__ + "static/4-3bf0c3e613e5d0482c9cd31f2f96c069.png";